import React, { FC } from 'react';
import { Link } from 'shared-routing';
import SectionHeader from '../SectionHeader';
import { Button } from '../Button';
import { NoSearchResultsWrapper } from './NoSearchResults.styles';

type NoSearchResultsProps = {
  headingText: string;
  linkRoute: string;
  linkText: string;
};

export const NoSearchResults: FC<NoSearchResultsProps> = ({ headingText, linkRoute, linkText }) => (
  <NoSearchResultsWrapper>
    <SectionHeader>{headingText}</SectionHeader>
    <Link route={linkRoute}>
      <Button>{linkText}</Button>
    </Link>
  </NoSearchResultsWrapper>
);
